export const state = function () {
  return {
    selected: "",
  }
}

export const mutations = {
  SET_SELECTED: function (state, new_selected) {
    state.selected = new_selected
  },
}

export const actions = {
  FETCH: async function ({ dispatch }) {
    return Promise.all([dispatch("mangopay/FETCH")])
  },
  RESET: function ({ commit }) {
    commit("SET_SELECTED", "")
    commit("paypal/RESET")
    commit("mangopay/RESET")
  },
}

export const getters = {
  PAYMENT_DATA: function (state, getters, rootState, rootGetters) {
    const draft = rootState.draft.id
    const transaction_type = rootGetters["payin/PURCHASE_TYPE"]
    const ret = {}

    if (transaction_type !== false) {
      if (rootGetters["payin/packs/IS_SELECTED"]) {
        ret.kind = "pack"
        ret.pack = rootState.payin.packs.selected
        ret.draft =
          draft > 0 && transaction_type === "sendtrack" ? draft : undefined
      } else if (draft > 0 && transaction_type === "sendtrack") {
        ret.kind = transaction_type
        ret.draft = draft
      } else {
        ret.kind = transaction_type
        ret.value = rootGetters["payin/FINAL_PURCHASE_AMOUNT"]
      }
      ret.legal_data = rootState.payin.billing_infos.legal_data.id
      ret.user = rootState.user.id
    }
    return ret
  },
}
